import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-contracts-col3',
    templateUrl: './contracts-col3.component.html',
    styleUrls: ['./contracts-col3.component.scss']
})
export class ContractsCol3Component implements OnInit {
    @Input() public hideSidebars = true;

    public openLeftSidebar = false;
    public openRightSidebar = false;

    closedLeftSidebar = this.hideSidebars;
    closedRightSidebar = this.hideSidebars;

    constructor() {
    }

    ngOnInit(): void {
    }


    toggleSidebar(e): void {
        if (e === 'left') {
            this.openLeftSidebar = !this.openLeftSidebar;
            if (this.openRightSidebar && this.openLeftSidebar) {
                this.openRightSidebar = false;
            }
        }
        if (e === 'right') {
            this.openRightSidebar = !this.openRightSidebar;
            if (this.openRightSidebar && this.openLeftSidebar) {
                this.openLeftSidebar = false;
            }
        }
    }

    hideSidebarByOverflow(): void {
        if (this.openLeftSidebar) {
            this.openLeftSidebar = !this.openLeftSidebar;
        }
        if (this.openRightSidebar) {
            this.openRightSidebar = !this.openRightSidebar;
        }
    }
}
